import {EffectiveEntryStatus} from './effective-entry-status'
import type {StackSectionStackEntry} from './merge-box-status-calculator/stack-section-status'
import {type LineTone, LINE_TONE_CLASS} from './stack-entry-line-tone'

// Each effective entry status maps to a "tone" — a Primer color bucket that
// matches the status icon's color (see the `effective-entry-status-icons`). The
// vertical line segment below an entry's icon is drawn in that tone, so the line
// flowing down from an icon reads as the same status as the icon it leaves.

const EFFECTIVE_STATUS_TONE: Record<EffectiveEntryStatus, LineTone> = {
  [EffectiveEntryStatus.After]: 'default',
  [EffectiveEntryStatus.BlockedDownstack]: 'attention',
  [EffectiveEntryStatus.Closed]: 'danger',
  [EffectiveEntryStatus.Draft]: 'default',
  [EffectiveEntryStatus.Loading]: 'default',
  [EffectiveEntryStatus.MergeConflicts]: 'attention',
  [EffectiveEntryStatus.Merged]: 'done',
  [EffectiveEntryStatus.Merging]: 'done',
  [EffectiveEntryStatus.NeedsRebase]: 'attention',
  [EffectiveEntryStatus.NotReady]: 'attention',
  [EffectiveEntryStatus.Queued]: 'attention',
  [EffectiveEntryStatus.Ready]: 'success',
}

function entryTone(entry: StackSectionStackEntry): LineTone {
  const status = entry.effectiveEntryStatus ?? EffectiveEntryStatus.NotReady
  return EFFECTIVE_STATUS_TONE[status]
}

// Returns the className to apply to a stack entry's `NavList.Item` so its
// vertical line segment matches the entry's `effectiveEntryStatus`.
export function getEffectiveEntryLineClass(entry: StackSectionStackEntry): string {
  return LINE_TONE_CLASS[entryTone(entry)]
}
